import type { ShadowShape } from "../api/types";
import { perDay, rate, rateTone, rateWord } from "../lib/shape";

/**
 * Удельный счёт КОЛОНКОЙ — рядом с колонкой «счёт».
 *
 * # Почему в таблице, а не только подписью под ней
 *
 * Потому что несравнимые суммы стоят именно в таблице, и исправлять их надо
 * там же. Первая версия этой правки жила только в подписи, и замер разметки
 * показал, чего она стоит: в панели смещённого края ставка оказывалась на
 * 16 604-м символе из 20 545 — то есть под таблицей в полсотни строк, куда
 * читающий сводку не доезжает. Число, которого не видно рядом с тем, что оно
 * исправляет, не исправляет ничего.
 *
 * # Почему СУТКИ, а не час
 *
 * Час — единица, в которой ставка измеряется, сутки — та, в которой её читают:
 * на теневых бюджетах часовые ставки идут центами, и колонка из «+$0.11» не
 * различала бы соседей. Часовая ставка вместе со СРОКОМ и плотностью
 * наблюдения едет в подписи под таблицей, где есть место их назвать, и в
 * подсказке этой ячейки.
 *
 * # Почему прочерк — это ответ
 *
 * Срок короче часа означает, что ставки нет: делить на срок короче единицы
 * значит не измерять, а экстраполировать (см. lib/shape). Ноль от прочерка при
 * этом отличается — «наблюдали, заработали ноль» и «считать было нечем» разные
 * утверждения о деньгах.
 */
export function RateCell({
  shape,
  hours,
  dim = false,
}: {
  shape: ShadowShape | undefined;
  /** Окно сводки — знаменатель ставки открывается его началом (lib/shape). */
  hours: number;
  /**
   * Гашение строки старше тона ставки: inline-цвет минуса перебивал бы класс
   * text-muted на `<tr>`, и самое громкое красное число стояло бы ровно в
   * строке, которую панель просит не читать.
   */
  dim?: boolean;
}) {
  return (
    <td
      className="num py-1.5 text-right"
      style={dim ? undefined : { color: rateTone(shape, hours) }}
      title={rateWord(shape, hours)}
    >
      {rate(perDay(shape, hours), "сут")}
    </td>
  );
}

/** Заголовок для колонки RateCell — чтобы шапка и ячейка не разъехались. */
export function RateHead() {
  return (
    <th
      className="pb-2 text-right font-normal"
      title="счёт за сутки работы: сумма, делённая на срок наблюдения"
    >
      $/сут
    </th>
  );
}
